import React from 'react';
import PropTypes from 'prop-types';
import {ApolloError} from 'apollo-client';

class GraphQLError extends React.Component {
    render() {
        const {graphQLErrors, networkError} = this.props.error;

        if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
            return graphQLErrors.map(({message, locations, path}) =>
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        }

        if (networkError) {
            return `[Network error]: ${networkError}`;
        }
    }
}

GraphQLError.propTypes = {
    error: PropTypes.instanceOf(ApolloError).isRequired
};

export default GraphQLError;


export const graphqlError = error => <GraphQLError error={error}/>;

